import { createFileRoute } from '@tanstack/react-router';
import { ArticleTable } from '@/components/Pages/Articles/ArticleTable';
import { CreateEditArticleModal } from '@/components/Pages/Articles/CreateEditArticleModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/articles/')({
  component: ArticlesPage,
});

function ArticlesPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditArticleModal />
        </Box>
      )}
      <ArticleTable />
    </Box>
  );
}
